import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-547942f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "rhead" }
const _hoisted_2 = { class: "dir" }
const _hoisted_3 = { id: "recordtables" }
const _hoisted_4 = { class: "table table-light table-striped" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("col", { style: {"width":"50px"} }, null, -1))
const _hoisted_6 = { class: "thead" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "thead",
  scope: "col"
}, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "thead",
  scope: "col"
}, " Points ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "thead",
  scope: "col"
}, " Team ", -1))
const _hoisted_10 = {
  key: 0,
  class: "thead",
  scope: "col"
}
const _hoisted_11 = {
  class: "thead",
  scope: "col"
}
const _hoisted_12 = { key: 0 }

import { Ref,  nextTick, onMounted, ref } from 'vue'
import ffWebsiteAPI from '@/services/ff-website-api';

interface rdata {
        record: string
        }

interface rdataInfo {
score: number,
pf: number,
full_name: string,
opp_full_name: string,
week: number,
season: number,
}



export default /*#__PURE__*/_defineComponent({
  __name: 'MyRecords',
  setup(__props) {

onMounted(() => {
  ffWebsiteAPI.ready = new Promise(resolve => {
      ffWebsiteAPI.resolver = resolve;
  });
  ffWebsiteAPI.resolver(1)
  fetchRecord();
});

async function fetchRecord() {
  try {
      const response = await ffWebsiteAPI.getRecord(records.value[0].record);
      tableData.value = response; 
      await nextTick()
    }
    catch (e) {
      console.log(e)
    }
}

let records: Ref<Array<rdata>> = ref([
    {record: "Top 50 Highest Single Game Scores"},
    {record: "Top 15 Points For Single Regular Season"},
    {record: "Top 15 Points Per Game Single Regular Season"},
    {record: "Top 15 Points For Single Postseason"},
    {record: "Top 15 Points Per Game Single Postseason"},
])


const tableData : Ref<Array<rdataInfo>>= ref([]);

function switchTable(event: Event) {
  const target = event.target as HTMLButtonElement;
  if (target != null) {
    target.disabled = true
    let newRecord = records.value.shift();
    if (newRecord != undefined) {
      records.value.push(newRecord);
      fetchRecord();
    }
    target.disabled = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(records)[0].record), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        id: "next",
        name: "next",
        class: "btn btn-light",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (switchTable($event)))
      }, "Next")
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("thead", _hoisted_6, [
          _createElementVNode("tr", null, [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9,
            (_unref(records)[0].record == 'Top 50 Highest Single Game Scores')
              ? (_openBlock(), _createElementBlock("th", _hoisted_10, " Opponent "))
              : _createCommentVNode("", true),
            _createElementVNode("th", _hoisted_11, " Year" + _toDisplayString(_unref(records)[0].record == 'Top 50 Highest Single Game Scores' ? (', Week') :  ''), 1)
          ])
        ]),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tableData.value, (row, index) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: row.score
            }, [
              _createElementVNode("td", null, _toDisplayString(index+1) + ".", 1),
              _createElementVNode("td", null, _toDisplayString(row.pf), 1),
              _createElementVNode("td", null, _toDisplayString(row.full_name), 1),
              (_unref(records)[0].record == 'Top 50 Highest Single Game Scores')
                ? (_openBlock(), _createElementBlock("td", _hoisted_12, _toDisplayString(row.opp_full_name), 1))
                : _createCommentVNode("", true),
              _createElementVNode("td", null, _toDisplayString((_unref(records)[0].record == 'Top 50 Highest Single Game Scores') ? `${row.season}, Week ${row.week}` : `${row.season}`), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})